export default __webpack_public_path__ + "static/media/partner-2.8667d9a6.png";